import React from "react";
import styles from "./banner.module.scss";

const Banner = () => {
  return (
    <div className={styles.wrapper}>
      <div className={styles.container}>
        <div className={styles.left}>
          <div className={styles.heading}>
            Hogi Pay Fast Way To Send Money Abroad
          </div>
          <div className={styles.text}>
            An international account to send money to over 60 countries around
            the world, up to 8x cheaper than a bank.{" "}
          </div>
        </div>
        <div className={styles.right}>
          <img className={styles.imgContainer} src={"/assets/banner.png"} />
        </div>
      </div>
      <div className={styles.scroll}>
        <img src={"/assets/scroll-down.png"}/>
      </div>
    </div>
  );
};

export default Banner;
